module.exports = __webpack_public_path__ + "img/carousel1.13997ac3.png";